module.exports = __webpack_public_path__ + "img/mi-team.37096a7d.svg";